


























import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class App extends Vue {
    private authenticated: boolean = false;
    private git_version: string = '1.0';
}
